import React from 'react';
import AnttButton from '../../../vendors/components/Button';
import {faDownload} from '@fortawesome/free-solid-svg-icons';
import If from '../../../vendors/components/If';

interface Props {
  anexo: any;
  handleDownload: any;
  showDownload: any;
}

export default function AnexoVisualizar({anexo, handleDownload, showDownload}: Props) {
  return (
    <>
      <div className="anexo-visualizar">
        <div className="nome-anexo">
          {anexo.noAnexo}
        </div>
        <If condition={showDownload}>
          <AnttButton
            onClick={() => handleDownload()}
            className="p-button-rounded p-button-rounded-info"
            faIcon={faDownload}
          />
        </If>
      </div>
    </>
  );
}